import { render, staticRenderFns } from "./remoteaccess_desktop.vue?vue&type=template&id=9daf7f1a&"
import script from "./remoteaccess_desktop.vue?vue&type=script&lang=js&"
export * from "./remoteaccess_desktop.vue?vue&type=script&lang=js&"
import style0 from "./remoteaccess_desktop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports